import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import moment from 'moment';

interface ISessioneState {
    UltimoControllo: Date;
}

export class Sessione extends React.PureComponent<Glob.IGlobaleProps, ISessioneState> {
    public constructor(props: any) {
        super(props);
        this.state = { UltimoControllo: new Date(Date.now()) };
        this.ControlloSessione();
    }

    public componentDidUpdate() {
        let Adesso = new Date();
        if (Adesso.getTime() - this.state.UltimoControllo.getTime() > Glob.IntervalloControlloSessione) {
            this.ControlloSessione();
            this.setState({ UltimoControllo: Adesso });
        }
    }

    private TornaAlLogin() {
        this.props.SetMenu(new Glob.CMenu());

        let PN: string = location.pathname.toLowerCase();

        if ((PN.indexOf("/log") != 0)
            && (PN != "/login")
            && ((PN != "/erroreaccesso") || (PN == "/erroreaccesso" && Glob.GetSessione().Sessione == ""))
            && (PN.indexOf("/fidecodicecontrollo") != 0)
            && (PN.indexOf("/recuperapassword") != 0)
            && (PN != "/")) {
            location.replace("/login");
        }
    }

    private ControlloSessione() {
        let S = Glob.GetSessione();
        if (S == undefined) {
            return; //L'ambiente non è ancora inizializzato
        }
        if (S.Sessione == "") {
            let Sessione = localStorage.getItem('Sessione');
            if (Sessione != "null" && Sessione != null) {
                S = JSON.parse(Sessione);
            }
        }

        if (S.Sessione != "") {
            let Sessione = S.Sessione;
            S = new Glob.CSessione();
            fetch('/api/Utenti/Sessione?sessione=' + Sessione)
                .then(response => {
                    if (response.ok) {
                        //(response.json() as Promise<Dati.CRisAPIDatoSessioni>).then(data => {
                        response.text().then(text => {
                            let data = JSON.parse(text, Glob.DateReviver) as Dati.CRisAPIDatoSessioni;
                            if (!data.Errore) {
                                S.Autorizzazioni = data.Dato.Autorizzazioni;
                                S.Cognome = data.Dato.Cognome;
                                S.ConfigurazioneCompilazione = data.Dato.ConfigurazioneCompilazione;
                                S.Email = data.Dato.Email;
                                S.Gruppi = data.Dato.Gruppi;
                                S.ID_Anag = data.Dato.ID_Anag;
                                S.ID_Utente = data.ID_Chiave;
                                S.ID_UtenteImpersonato = data.Dato.ID_UtenteImpersonato;
                                S.Immagine = data.Dato.Immagine;
                                S.Limiti = data.Dato.Limiti;
                                S.Livello = data.Dato.Livello;
                                S.Login = data.Dato.Login;
                                S.Nome = data.Dato.Nome;
                                S.Scadenza = data.Dato.Scadenza;
                                S.ScadenzaMax = data.Dato.ScadenzaMax;
                                S.Sessione = data.Dato.Sessione;
                                S.Versione = data.Dato.Versione;
                                this.props.SetSessione(S);
                            }
                            else {
                                Glob.Log(Glob.LogCat.Sessione, false, "Errore caricamento Sessione (Dati)", data);
                                this.props.SetSessione(S);
                                this.TornaAlLogin();
                            }
                        }).catch(e => {
                            Glob.Log(Glob.LogCat.Sessione, false, "Errore caricamento Sessione (JSON)", e);
                            this.props.SetSessione(S);
                            this.TornaAlLogin();
                        });
                    }
                    else {
                        Glob.Log(Glob.LogCat.Sessione, false, "Errore caricamento Sessione (HTTP)", response);
                        //this.props.SetSessione(S);
                        //this.TornaAlLogin();
                    }
                })
                .catch(e => {
                    Glob.Log(Glob.LogCat.Sessione, false, "Errore caricamento Sessione (Rete)", e);
                    this.props.SetSessione(S);
                    this.TornaAlLogin();
                });
        }
        else {
            this.TornaAlLogin();
        }
    }

    public render() {
        let S = Glob.GetSessione();
        if (S != undefined) {
            return <span>{S.Sessione} {S.ID_Utente} {S.ID_UtenteImpersonato} {S.Livello} {S.Login} <br />{S.ConfigurazioneCompilazione} {S.Versione} {moment(S.Scadenza).format('DD/MM/YYYY HH:mm:ss')}</span>;
        }
        else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Sessione.tsx